import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [12,[2]],
		"/(app)/activity": [13,[2,3]],
		"/(app)/admin": [14,[2,4]],
		"/(app)/admin/analytics": [15,[2,4]],
		"/(app)/admin/analytics/[tab]": [16,[2,4]],
		"/(app)/admin/approvals": [17,[2,4]],
		"/(app)/admin/billing": [18,[2,4]],
		"/(app)/admin/evaluations": [19,[2,4]],
		"/(app)/admin/evaluations/[tab]": [20,[2,4]],
		"/(app)/admin/functions": [21,[2,4]],
		"/(app)/admin/functions/create": [22,[2,4]],
		"/(app)/admin/functions/edit": [23,[2,4]],
		"/(app)/admin/settings": [24,[2,4]],
		"/(app)/admin/settings/[tab]": [25,[2,4]],
		"/(app)/admin/users": [26,[2,4]],
		"/(app)/admin/users/[tab]": [27,[2,4]],
		"/(app)/artifacts": [28,[2]],
		"/(app)/artifacts/[id]": [29,[2]],
		"/(app)/assistants": [30,[2,5]],
		"/(app)/assistants/create": [32,[2,5]],
		"/(app)/assistants/templates": [33,[2,5]],
		"/(app)/assistants/[id]": [31,[2,5]],
		"/auth": [69],
		"/auth/forgot-password": [70],
		"/auth/reset-password": [71],
		"/(app)/automations": [34,[2,6]],
		"/(app)/automations/create": [36,[2,6]],
		"/(app)/automations/edit/[id]": [37,[2,6]],
		"/(app)/automations/[id]/runs": [35,[2,6]],
		"/a/[id]": [68],
		"/(app)/billing": [38,[2]],
		"/(app)/channels/[id]": [40,[2]],
		"/(app)/c/[id]": [39,[2]],
		"/error": [72],
		"/explore/agents": [73],
		"/explore/artifacts": [74],
		"/(app)/home": [41,[2,7]],
		"/invite/[token]": [75],
		"/join/[code]": [76],
		"/(app)/notes": [42,[2,8]],
		"/(app)/notes/new": [44,[2,8]],
		"/(app)/notes/[id]": [43,[2,8]],
		"/(app)/openclaw": [45,[2,9]],
		"/(app)/playground": [47,[2,10]],
		"/(app)/playground/completions": [48,[2,10]],
		"/(app)/pulse": [49,[2]],
		"/(app)/p/[id]": [46,[2]],
		"/s/[id]": [77],
		"/t/[id]": [78],
		"/watch": [79],
		"/(app)/workspace": [50,[2,11]],
		"/(app)/workspace/automations": [51,[2,11]],
		"/(app)/workspace/automations/create": [53,[2,11]],
		"/(app)/workspace/automations/edit/[id]": [54,[2,11]],
		"/(app)/workspace/automations/[id]/runs": [52,[2,11]],
		"/(app)/workspace/functions/create": [55,[2,11]],
		"/(app)/workspace/knowledge": [56,[2,11]],
		"/(app)/workspace/knowledge/create": [58,[2,11]],
		"/(app)/workspace/knowledge/[id]": [57,[2,11]],
		"/(app)/workspace/models": [59,[2,11]],
		"/(app)/workspace/models/create": [60,[2,11]],
		"/(app)/workspace/models/edit": [61,[2,11]],
		"/(app)/workspace/prompts": [62,[2,11]],
		"/(app)/workspace/prompts/create": [63,[2,11]],
		"/(app)/workspace/prompts/edit": [64,[2,11]],
		"/(app)/workspace/tools": [65,[2,11]],
		"/(app)/workspace/tools/create": [66,[2,11]],
		"/(app)/workspace/tools/edit": [67,[2,11]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';